import React from "react";

import { useNavigate } from "react-router-dom";
import { routes } from "consts";
import { HeaderWithBreadcrumbs } from "components/molecules/HeaderWithBreadcrumbs/HeaderWithBreadbrumbs";
import { PlaceTagForm, PlaceTagFormValues } from "./PlaceTagForm/PlaceTagForm";
import { placeTagsApi } from "api/placeTagsApi";
import { useToaster } from "utils";
import { PageMain } from "components/molecules";

export const PlaceTagAddPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError } = useToaster();

  const onSubmit = async (data: PlaceTagFormValues) => {
    try {
      await placeTagsApi.create(data);
      navigate(routes.PLACE_TAGS);
      showSuccess("Dodano nowy tag");
    } catch (e) {
      showError("Nie udało się dodać nowego tagu");
      console.error(e);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs
        breadcrumbs={[
          { title: "Miejsca", path: routes.PLACES },
          { title: "Tagi", path: routes.PLACE_TAGS },
          { title: "Tworzenie nowego tagu" },
        ]}
        headerText="Dodaj nowy tag"
      />
      <PlaceTagForm onSubmit={onSubmit} />
    </PageMain>
  );
};
